module.exports = __webpack_public_path__ + "static/media/invitado1.0a00e50d.jpg";